import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="M" transform="translate(11.000000, 5.000000)">
        <path
          d="M26 30.3 L26 61 L31.5 61 L31.5 40 L39 49 L46.5 40 L46.5 61 L52 61 L52 30.3 L45 30.3 L39 38 L33 30.3 L26 30.3 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
